// extracted by mini-css-extract-plugin
export default {"darkRow":"SimpleTableRow_darkRow__VSC9R","lightRow":"SimpleTableRow_lightRow__azEHP","actionButton":"SimpleTableRow_actionButton__ghSOr"};